/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthModel } from "./_models";

const AUTH_LOCAL_STORAGE_KEY = "stream-auth-token";
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return;
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return;
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel;
    if (auth) {
      // You can easily check auth_token expiration also
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE SAVE ERROR", error);
  }
};

const removeAuth = () => {
  if (!localStorage) {
    return;
  }

  try {
    // stream_onboarding_setup_steps is preserved so the client-only "product"
    // step flag (no backend source of truth) survives logout — kyb/contract
    // on it get re-reconciled against the backend on next load anyway.
    const preserveKeys = [
      "i18nConfig",
      "direction",
      "stream_onboarding_setup_steps",
      // Per-user map: once /onboarding-intro was shown, skip it after re-login.
      "stream_onboarding_intro_seen",
      // Per-user map: notification read state (backend has no read flag).
      "stream_notifications_read",
    ];
    const preserved: Record<string, string> = {};

    preserveKeys.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        preserved[key] = value;
      }
    });

    localStorage.clear();

    Object.entries(preserved).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  } catch (error) {
    console.error("AUTH LOCAL STORAGE CLEAR ERROR", error);
  }
};

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = "application/json";
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const auth = getAuth();
      if (auth && auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err)
  );
}

export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY };
